/**
 * Loads the large country-map SVG overlays on product cards only when the card is about to enter the viewport.
 * Markup: <img src="<1px placeholder>" data-lazy-src="<map url>">.
 */
(function () {
  if (window.__lazyCardMapsInit) return;
  window.__lazyCardMapsInit = true;

  const SELECTOR = 'img[data-lazy-src]';

  function load(img) {
    img.src = img.dataset.lazySrc;
    img.removeAttribute('data-lazy-src');
  }

  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              observer.unobserve(entry.target);
              load(entry.target);
            });
          },
          { rootMargin: '200px' }
        )
      : null;

  function observeAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach((img) => (observer ? observer.observe(img) : load(img)));
  }

  observeAll();
  document.addEventListener('shopify:section:load', (event) => observeAll(event.target));
  new MutationObserver((mutations) => {
    mutations.forEach((m) => m.addedNodes.forEach((n) => n.nodeType === 1 && observeAll(n)));
  }).observe(document.body, { childList: true, subtree: true });
})();
